import React, { useState } from "react";
import { Button, Modal, Form } from "semantic-ui-react";
import { toast } from "react-toastify";

import { formatNumber, isEmailValid } from "../../utils/functions";
import { sendEmail2Seller } from "../../utils/api";

const EmailModal = ({ open, dealerEmail, make, price, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: `Hi, I'm interested in this ${make} for £${formatNumber(
      price
    )}. Please could you contact me back.`,
    receiver: dealerEmail,
  });
  const [validationErr, setValidationErr] = useState({
    firstName: false,
    lastName: false,
    email: false,
    message: false,
  });
  const [formBusy, setFormBusy] = useState(false);

  const checkValidationandShowErr = () => {
    let isValid = true;
    let errors = {
      firstName: false,
      lastName: false,
      email: false,
      message: false,
    };

    if (formData.firstName === "") {
      errors.firstName = "Please input your first name";
      isValid = false;
    }
    if (formData.lastName === "") {
      errors.lastName = "Please input your last name";
      isValid = false;
    }
    if (formData.email === "") {
      errors.email = "Please input your email";
      isValid = false;
    } else if (!isEmailValid(formData.email)) {
      errors.email = "Please input the valid email";
      isValid = false;
    }
    if (formData.message === "") {
      errors.message = "Please input the message";
      isValid = false;
    }

    setValidationErr(errors);
    return isValid;
  };

  const sendEmail = () => {
    if (formBusy) return;

    if (checkValidationandShowErr()) {
      setFormBusy(true);
      sendEmail2Seller(formData)
        .then(() => {
          toast.success("✔️ The email is sent to the seller.", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          setTimeout(() => onClose(), 800);
        })
        .catch(() => {
          toast.error("❌ Something went wrong.", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
        })
        .finally(() => setFormBusy(false));
    }
  };

  const handleChange = (e, { name, value }) => {
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Modal size={"tiny"} open={open} onClose={onClose} closeIcon>
      <Modal.Header>Contact the seller</Modal.Header>
      <Modal.Content>
        <Form loading={formBusy}>
          <Form.Group widths="equal">
            <Form.Input
              label="First Name"
              name="firstName"
              onChange={handleChange}
              value={formData.firstName}
              required
              error={validationErr.firstName}
            />
            <Form.Input
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              error={validationErr.lastName}
            />
          </Form.Group>
          <Form.Input
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            error={validationErr.email}
          />
          <Form.Input
            label="Phone"
            name="phone"
            onChange={handleChange}
            value={formData.phone}
          />
          <Form.TextArea
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            error={validationErr.message}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button primary fluid onClick={sendEmail} disabled={formBusy}>
          Send
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EmailModal;
